import { render } from "./SpmKeyCard.vue?vue&type=template&id=5e21069e&scoped=true"
import script from "./SpmKeyCard.vue?vue&type=script&lang=ts"
export * from "./SpmKeyCard.vue?vue&type=script&lang=ts"

import "./SpmKeyCard.vue?vue&type=style&index=0&id=5e21069e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e21069e"

export default script